import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FORM_MODELS } from '../../../reducers/form.reducer';
import { convertBeToFe, convertFeToBe } from '../../../utils';
import { crudActions, userActions } from '../../../actions';
import { CRUD_MODELS, RESEARCH_DIRECTION_MODEL, USER_CONSTANTS } from '../../../constants';

import KPTextform from '../../KPTComponents/KPTextform';

import SachForm from '../../../containers/Crud/Sach/SachForm';
import DeTaiForm from '../../../containers/Crud/DeTai/DeTaiForm';
import BaiBaoForm from '../../../containers/Crud/BaiBao/BaiBaoForm';
import KyLuatForm from '../../../containers/Crud/KyLuat/KyLuatForm';
import BangCapForm from '../../../containers/Crud/BangCap/BangCapForm';
import NhiemVuForm from '../../../containers/Crud/NhiemVu/NhiemVuForm';
import SangCheForm from '../../../containers/Crud/SangChe/SangCheForm';
import TacPhamForm from '../../../containers/Crud/TacPham/TacPhamForm';
import CongTacForm from '../../../containers/Crud/CongTac/CongTacForm';
import HuongDanForm from '../../../containers/Crud/HuongDan/HuongDanForm';
import KhenThuongForm from '../../../containers/Crud/KhenThuong/KhenThuongForm';
import ChuongTrinhForm from '../../../containers/Crud/ChuongTrinh/ChuongTrinhForm';
import QuaTrinhDaoTaoForm from '../../../containers/Crud/QuaTrinhDaoTao/QuaTrinhDaoTaoForm';


function CrudForm({ id='thanh-tich-insert', type, defaultValues, filterType, setPreview, thamDinhCode, disabled=false, ...props }) {
  const dispatch = useDispatch();

  const [values, setValues] = useState(null);

  const form = useSelector((state) => state.formReducer.form);
  const profile = useSelector((state) => state.profileReducer.profile);
  // console.log(form);

  useEffect(() => {
    if (!defaultValues && filterType) {
      defaultValues = { filterType }
    }
    // console.log('defaultValues', defaultValues, filterType);
    if (id === 'thanh-tich-insert-copy') {
      let tmpData = {};
      if (thamDinhCode == "tham_dinh_1") {
        tmpData = defaultValues?.thamDinh1Data ? convertBeToFe(JSON.parse(defaultValues?.thamDinh1Data || '{}'), FORM_MODELS[type]) : defaultValues;
      }
      else if (thamDinhCode == "tham_dinh_2") {
        tmpData = defaultValues?.thamDinh2Data ? convertBeToFe(JSON.parse(defaultValues?.thamDinh2Data || '{}'), FORM_MODELS[type]) : defaultValues;
      }
      else if (thamDinhCode == "tham_dinh_3") {
        tmpData = defaultValues?.thamDinh3Data ? convertBeToFe(JSON.parse(defaultValues?.thamDinh3Data || '{}'), FORM_MODELS[type]) : defaultValues;
      } else {
        tmpData = defaultValues;
      }
      defaultValues = {
        ...tmpData,
        proof: typeof tmpData?.proof === 'string' ? JSON.parse(tmpData?.proof) : tmpData?.proof,
        filterType: filterType
      };
    }
    setValues(defaultValues || {});
  }, [defaultValues]);
  
  // console.log(defaultValues, values);
  
  const handleSubmit = async () => {
    if (profile?.submittable === false && profile?.userRole === USER_CONSTANTS.ROLE.candidate) {
      // props.handleClose();
      dispatch(userActions.notification({ message: 'Đã hết thời gian nộp hồ sơ', type: 'warning' }));
      return;
    }
    dispatch(userActions.setLoadingGlobal(true));
    // console.log('handleSubmit', values, FORM_MODELS[type], form.id);
    const converted = await convertFeToBe(values, FORM_MODELS[type], '/form/' + form.id);
    dispatch(userActions.setLoadingGlobal(false));

    if (converted.error) {
      dispatch(userActions.notification({ message: converted.error, type: 'error' }));
      return;
    }
    
    const payload = {
      ...converted.values,
      // filterType: converted.filterType || filterType,
      profileId: form.profileId || profile.id,
      applicationFormId: form.id,
      journalHIndex: parseFloat(converted.values.journalHIndex) || 0,
    };
    // console.log(payload);

    if (id === 'thanh-tich-insert-copy') {
      // const newConverted = await convertFeToBe(defaultValues, FORM_MODELS[type], '/form/' + form.id);
      // console.log('handleSubmit - insert copy', defaultValues, payload);
      const newPayload = {
        ...defaultValues,
        issueDate: payload.issueDate,
        proof: payload.proof,
        profileId: profile.id,
        applicationFormId: form.id,
        thamDinhCode: thamDinhCode,
        // id: defaultValues.id, // keep id to update
        // filterType: payload.filterType,
      };
      // console.log(newPayload, thamDinhCode);
      // thamDinhCode = thamDinhCode || "tham_dinh_1";
      if (thamDinhCode == "tham_dinh_1") {
        newPayload.thamDinh1Data = JSON.stringify(payload);
      }
      if (thamDinhCode == "tham_dinh_2") {
        newPayload.thamDinh2Data = JSON.stringify(payload);
      }
      if (thamDinhCode == "tham_dinh_3") {
        newPayload.thamDinh3Data = JSON.stringify(payload);
      }
      dispatch(crudActions.update(type, newPayload, true)); // checkThamDinh = true
    } else {
      if (payload.id) {
        dispatch(crudActions.update(type, payload));
      } else {
        dispatch(crudActions.insert(type, payload));
      }
    }

    props.handleClose();
  };

  const formMapComponent = useMemo(() => {
    const formProps = { id: id, disabled, values, setValues, handleSubmit, setPreview};

    const formMap = {
      [CRUD_MODELS.AWARD]: <TacPhamForm { ...formProps } />,
      [CRUD_MODELS.REWARD]: <KhenThuongForm { ...formProps } />,
      [CRUD_MODELS.PROGRAM]: <ChuongTrinhForm { ...formProps } />,
      [CRUD_MODELS.SOLUTION]: <SangCheForm { ...formProps } />,
      [CRUD_MODELS.MONOGRAPH]: <SachForm { ...formProps } />,
      [CRUD_MODELS.DISCIPLINE]: <KyLuatForm { ...formProps } />,
      [CRUD_MODELS.EDUCATE_DEGREE]: <BangCapForm { ...formProps } />,
      [CRUD_MODELS.WORKING_PROCESS]: <CongTacForm { ...formProps } />,
      [CRUD_MODELS.SCIENTIFIC_TASK]: <NhiemVuForm { ...formProps } />,
      [CRUD_MODELS.RESEARCH_PROJECT]: <DeTaiForm { ...formProps } />,
      [CRUD_MODELS.TRAINEE_GUIDANCE]: <HuongDanForm { ...formProps } />,
      [CRUD_MODELS.SCIENTIFIC_RESEARCH]: <BaiBaoForm { ...formProps } filterType={filterType} />,
      
      [CRUD_MODELS.RESEARCH_DIRECTION]: <KPTextform
        { ...formProps }
        textForm={[
          { ...RESEARCH_DIRECTION_MODEL.title, xs: 12 },
          { ...RESEARCH_DIRECTION_MODEL.description, xs: 12 },
        ]}
      />,

      // TH Đặc biệt: Update form
      'educateProcess': <QuaTrinhDaoTaoForm
        { ...formProps }
        handleSubmit={(values) => {
          const educateProcess = props.values.educateProcess;
          educateProcess[values.id] = values;
          props.saveForm({ educateProcess })
          props.handleClose();
        }} />
    }

    if (!type || !formMap.hasOwnProperty(type)) return null;
    return formMap[type];
  }, [values, type, filterType]);

  return values ? formMapComponent : null;
}

export default CrudForm;
